export const setPayouts = {
  SET_PAYOUTS(state, payload) {
    state.payouts = payload;
  }
};
